export default __webpack_public_path__ + "static/media/niftynext50-survivorship-outperformance-graph.66242671.png";